import type * as THREE from 'three';
import {
  createIceMaterial,
  createPaintUniform,
  createSnowMaterial,
  type SnowMaterialOptions,
} from '../paint/snowMaterial';
import type { PaintableDef } from './Location';

/**
 * Wiring glue between a location's meshes and the paint system: creates the
 * snow/ice material with a fresh paint uniform, and records everything the
 * Game needs to spin up a PaintSurface for the mesh.
 */

export function paintableSnowMaterial(options: Omit<SnowMaterialOptions, 'paintUniform'> = {}): {
  material: THREE.MeshStandardMaterial;
  uniform: { value: THREE.Texture };
} {
  const uniform = createPaintUniform();
  return { material: createSnowMaterial({ ...options, paintUniform: uniform }), uniform };
}

export function paintableIceMaterial(
  options: Omit<Parameters<typeof createIceMaterial>[0], 'paintUniform'> = {},
): { material: THREE.MeshStandardMaterial; uniform: { value: THREE.Texture } } {
  const uniform = createPaintUniform();
  return { material: createIceMaterial({ ...options, paintUniform: uniform }), uniform };
}

/** Register `mesh` as a paintable surface. */
export function registerPaintable(
  paintables: PaintableDef[],
  id: string,
  mesh: THREE.Mesh,
  uniform: { value: THREE.Texture },
  large: boolean,
): void {
  mesh.userData.paintUniform = uniform;
  mesh.userData.largePaintSurface = large;
  paintables.push({ id, mesh, large });
}
